import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { SystemNotificationsService } from '@fi-app/system-notifications/system-notifications.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'fi-system-notifications-icon',
    templateUrl: './system-notifications-icon.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./system-notifications-icon.component.scss'],
    standalone: false,
})
export class SystemNotificationsIconComponent implements OnDestroy, OnInit {
    systemNotificationsCount$ = new BehaviorSubject<number>(0);

    constructor(
        private systemNotificationsService: SystemNotificationsService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.systemNotificationsService.systemNotificationsCount$
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe((data) => {
                this.systemNotificationsCount$.next(data);
                this.cdr.detectChanges();
            });
    }

    toggleSystemNotifications() {
        this.systemNotificationsService.opened = !this.systemNotificationsService.opened;
    }

    ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
